import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Calendar, Badge  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';
import moment from 'moment'
import Getteachet2 from './Getteachet2';
import Getprograme from './Getprograme';
import Modalpayedit from './Modalpayedit';
moment.updateLocale('en', {
  weekdaysMin : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
});



export default class Reporttess2 extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          dd3:'',
          teacher:'',
          prenm:'',
          term:'',
          type:'',
          poname:'',
          typename:'ยังไม่ระบุ',
         
        };
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);
        this.getListData = this.getListData.bind(this);
        this.dateCellRender = this.dateCellRender.bind(this);
        this.updateSearchtype = this.updateSearchtype.bind(this);
        this.getthschedule1 = this.getthschedule1.bind(this);
        this.exportpdf = this.exportpdf.bind(this);
      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
           setTimeout(() => {
             this.getthschedule1()
           }, 500);
    }


    getthschedule1() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
           .then(res => {
            // console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


  
      
    updateSearchtype(value) {
      // console.log(event.target.value)
      // const term = event.target.value;
      const type = value;
      this.setState({ type });
        //  setTimeout(() => {
        //    this.getthschedule()
        //  }, 500);
      if (type == 1) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร' });
      }
      if (type == 2) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร' });
      }
      if (type == 3) {
        this.setState({ typename :'ภาคกศ.บป.กำแพงเพชร แม่สอด' });
      }
      if (type == 5) {
        this.setState({ typename :'ภาคปกติกำแพงเพชร แม่สอด' });
      }

    }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthschedulesearch/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


      getteachingschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showteachingschedule/'+this.state.term+'/'+this.state.idemp)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ showteachingschedule: res.data})

             if (res.data.length !== 0) {
               const teacher = res.data[0].poname;
             //  const prenm = res.data[0].prenm;
               this.setState({ teacher });
             //  this.setState({ prenm });
             }
             
           }) 
         }, 0);
      }

   

      onChange(value) {
          console.log(`selected ${value}`);
          const idemp = value;
          this.setState({ idemp });


          const teachersearcha = this.state.thschedule.filter( ({ user_teacher }) => user_teacher === idemp );
          this.setState({ poname : teachersearcha[0].poname});
          this.setState({ prenm : teachersearcha[0].prenm});


          setTimeout(() => {
            this.getteachingschedule()
          }, 500);
     }


          onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          
           getListData(value) {
             let listData;
             this.state.showteachingschedule.map((showteachingschedule) => {
             // let daysum = Number(showteachingschedule.ss)
              //  for (let  index = 0; index < 5; index++) {
              //       daysum = daysum + 7;
              //       if (value.week() === daysum) {
              //        listData = [
              //               { type: 'warning', content: 'This is warning event.' },
              //               { type: 'success', content: 'This is usual event.' },
              //             ];
              //      }
              //  }

               if (value.weekdaysMin() === "Sun") {
                listData = [
                       { type: 'warning', content: 'This is warning event.' },
                       { type: 'success', content: 'This is usual event.' },
                     ];
               }
             
            //  <>{showteachingschedule.ss}  </>  
            return listData || [];
             });


            // let listData = this.state.showteachingschedule.map((showteachingschedule) =>
            
            // <li key={showteachingschedule.toString()}> {showteachingschedule.ss} </li>
            // );
           //  let  lissd = 'sds';
           //  let  lisd =  this.state.showteachingschedule.map((showteachingschedule) =>  <>{showteachingschedule.ss}  </>  );
          

         //console.log('dddd'+lissd);
        
     
          //   switch (value.date()) {
          
          //      case 5:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //       ];
          //       break;
          //     case 7:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //       ];
          //       break;
          //     case 10:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event.' },
          //         { type: 'success', content: 'This is usual event.' },
          //         { type: 'error', content: 'This is error event.' },
          //       ];
          //       break;
          //     case 15:
          //       listData = [
          //         { type: 'warning', content: 'This is warning event' },
          //         { type: 'success', content: 'This is very long usual event。。....' },
          //         { type: 'error', content: 'This is error event 1.' },
          //         { type: 'error', content: 'This is error event 2.' },
          //         { type: 'error', content: 'This is error event 3.' },
          //         { type: 'error', content: 'This is error event 4.' },
          //       ];
          //       break;
          //     default:
          //   }
             return listData || [];
           }


           dateCellRender(value) {
            const listData = this.getListData(value);
            return (
              <ul className="events">
                {listData.map(item => (
                  <li key={item.content}>
                    <Badge status={item.type} text={item.content} />
                  </li>
                ))}
              </ul>
            );
           }
          
           getMonthData(value) {
            if (value.month() === 8) {
              return 1394;
            }
           }
          
           monthCellRender(value) {
            const num = this.getMonthData(value);
            return num ? (
              <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
              </div>
            ) : null;
          }

          exportpdf = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
          //  console.log("dfdf")
                setTimeout(() => {
                   console.log(id)
                   window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+id, '_blank');
                 
                  
                 }, 1000); 

          }




    render() {

      console.log(this.state.type)
      console.log(this.state.term)
      

        const { Option } = Select;
        const online = window.navigator.onLine;
      //  const teacher =  this.state.teachingschedule[0].map(teachingschedules => { {teachingschedule.poname} }  )     
      if (navigator.onLine) {
        console.log('online');
      } else {
        console.log('offline');
      }
      

      //ปฏิทิน




      const data = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ-นามสกุล',
            field: 'Curriculumopen_TEAM',
            sort: 'Curriculumopen_TEAM',
            width: 270
          },
        
          {
            label: 'จัดการ',
            field: 'Curriculumopen_Full_Name_EN',
            sort: 'Curriculumopen_Full_Name_EN',
            width: 100
          }


        ],

        rows: [...this.state.thschedule.map((data, i) => (
          {
             list: <>{i+1}</>,
             Curriculumopen_TEAM: <>{data.prenm}{data.poname}</>,
             Curriculumopen_Full_Name_EN: <> <MDBBtn color="unique" size="sm"  onClick={() => this.exportpdf(data.teacher_id1)}> <MDBIcon icon="print" /> พิมพ์</MDBBtn></>

          }
         ))]
        
    
    };

    const persons = <MDBDataTable
    // searching ={true}
     searchLabel="ค้นหา ชื่อ"
     striped
     bordered
     small 
     entries={20}
    // entriesOptions={["10", "20"]}
     order={["age", "desc"]}
     data={data}
     entriesLabel="จำนวนที่แสดง "
     infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
     paginationLabel={["ย้อนกลับ", "ถัดไป"]}
     responsive 
     sortRows={['random']}
     />


        return (
            <MDBContainer fluid>
              
    <Card type="inner"  title={<h4 className="unique-text"><MDBIcon icon="book" /> รายงานตารางสอน แบบรายคน</h4>} >
    <MDBRow>
           
            <MDBCol sm="4">
              <p>เลือกภาคเรียน</p>
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.term}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {/* <Option value="3/2563">3/2563</Option>
                            <Option value="1/2564">1/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="3/2564">3/2564</Option> */}
                            <Option value="1/2565">1/2565</Option>
                            <Option value="2/2565">2/2565</Option>
                            <Option value="3/2565">3/2565</Option>
                            <Option value="1/2566">1/2566</Option>
                            <Option value="2/2566">2/2566</Option>
                            <Option ative value="3/2566">3/2566</Option>
                            <Option value="1/2567">1/2567</Option>
                            <Option value="2/2567">2/2567</Option>
                            <Option ative value="3/2567">3/2567</Option>
                            <Option value="1/2568">1/2568</Option>
                            <Option value="2/2568">2/2568</Option>
                            <Option value="3/2568">3/2568</Option>

                        </Select>
                    </div>
                    {/* <br/> */}

            </MDBCol>
            
            <MDBCol sm="8">
              {/* <p>เลือกประเภทนักศึกษา</p>
                <div>
                    <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />   
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกประเภทนักศึกษา"
                            optionFilterProp="children"
                            onChange={this.updateSearchtype}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.type}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            <Option value="1">ปกติกำแพงเพชร</Option>
                            <Option value="2">กศ.บป.กำแพงเพชร</Option>
                            <Option value="3">กศ.บป.กำแพงเพชร แม่สอด</Option>
                            <Option value="5">ปกติกำแพงเพชร แม่สอด</Option>
                           
                        </Select>
                    </div> */}
            </MDBCol>

  </MDBRow>

{persons}


        </Card>
        {/* <Calendar dateCellRender={this.dateCellRender} monthCellRender={this.monthCellRender} />, */}
            </MDBContainer>

        )
    }
}
